import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { IVehicleBlacklistAddPayload } from "../../Components/vehicle-blacklist/types";
import { VEHICLE_BLACKLIST_INITIAL_STATE } from "../constants/vehicleBlacklist.constants";

export const getAllVehicleBlacklists = createAsyncThunk(
  "vehicleBlacklists/getAll",
  async () => {
    const response = await axios.get("/api/Customer/vehicle/blackList/List");
    return response.data;
  }
);

export const getAllVehicles = createAsyncThunk(
  "vehicleBlacklists/getAllVehicles",
  async () => {
    const response = await axios.get("/api/Customer/vehicle/GetAll");
    return response.data;
  }
);

export const addVehicleBlacklist = createAsyncThunk(
  "vehicleBlacklists/add",
  async (data: IVehicleBlacklistAddPayload) => {
    const response = await axios.post(
      "/api/Customer/vehicle/blackList/add",
      data
    );
    return response.data;
  }
);

export const deleteVehicleBlacklist = createAsyncThunk(
  "vehicleBlacklists/delete",
  async ({ refId, updatedBy }: { refId: string; updatedBy: string }) => {
    const response = await axios.post(
      `/api/Customer/vehicle/blackList/${refId}?updatedBy=${updatedBy}`
    );
    return response.data;
  }
);

export const vehicleBlacklistSlice = createSlice({
  name: "vehicleBlacklist",
  initialState: VEHICLE_BLACKLIST_INITIAL_STATE,
  reducers: {
    onChangeVehicleBlacklistScreen: (state, action) => {
      state.currentScreen = action.payload;
    },
    onChangeVehicleBlacklistList: (state, action) => {
      state.pageProps = action.payload;
    },
    onSelectVehicleBlacklist: (state, action) => {
      state.selectedVehicleBlacklist = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllVehicleBlacklists.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllVehicleBlacklists.fulfilled, (state, action) => {
        state.loading = false;
        // Transform the API response to match our pagination structure
        const result = action.payload?.result || [];
        state.data = {
          list: result,
          totalPages: Math.ceil(result.length / state.pageProps.perPage),
          totalRecords: result.length,
        };
        state.error = null;
      })
      .addCase(getAllVehicleBlacklists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(addVehicleBlacklist.pending, (state) => {
        state.loading = true;
      })
      .addCase(addVehicleBlacklist.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addVehicleBlacklist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(deleteVehicleBlacklist.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVehicleBlacklist.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteVehicleBlacklist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      })
      .addCase(getAllVehicles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllVehicles.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicles = action.payload?.result || [];
        state.error = null;
      })
      .addCase(getAllVehicles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred.";
      });
  },
});

export const {
  onChangeVehicleBlacklistScreen,
  onChangeVehicleBlacklistList,
  onSelectVehicleBlacklist,
} = vehicleBlacklistSlice.actions;

export default vehicleBlacklistSlice.reducer;
